import { useMemo, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import useFetch from '../hooks/useFetch'
import { useToken } from '../auth/hooks'
import { BASE_URL } from '../constants'

import {
  setIncidentDisplayOrder,
  setSigEventDisplayOrder,
  setShowClosedSigEvents,
  setTimestampFormat,
  setDefaultBasemap,
  setTraffic,
  fetchStart,
  fetchSuccess,
  fetchFail,
} from './actions'
import { getUser, getPreferences } from './selectors'

export const useUser = () => {
  const state = useSelector(getUser)
  return state
}

export const useUserPreferences = () => {
  const dispatch = useDispatch()
  const preferences = useSelector(getPreferences)
  const token = useToken()

  const actions = useMemo(
    () => ({
      setIncidentDisplayOrder: (value) =>
        dispatch(setIncidentDisplayOrder(token, value)),
      setSigEventDisplayOrder: (value) =>
        dispatch(setSigEventDisplayOrder(token, value)),
      setTimestampFormat: (value) => dispatch(setTimestampFormat(token, value)),
      setDefaultBasemap: (value) => dispatch(setDefaultBasemap(token, value)),
      setTraffic: (value) => dispatch(setTraffic(token, value)),
      setShowClosedSigEvents: (value) =>
        dispatch(setShowClosedSigEvents(token, value)),
    }),
    [dispatch, token]
  )

  return [preferences, actions]
}

export const useUserPreference = (preference) => {
  const preferences = useSelector(getPreferences)
  return preferences[preference]
}

export const useUserPreferencesFetch = () => {
  const dispatch = useDispatch()

  useFetch(`${BASE_URL}api/preferences`, {
    onStart: () => dispatch(fetchStart()),
    onSuccess: (prefs) => dispatch(fetchSuccess(prefs)),
    onError: (error) => dispatch(fetchFail(error)),
  })
}

export const useUserLocation = () => {
  const [location, setLocation] = useState({
    latitude: 33.933995,
    longitude: -78.938501,
  })

  useEffect(
    () =>
      navigator.geolocation &&
      navigator.geolocation.getCurrentPosition(
        (position) => setLocation(position.coords),
        undefined,
        {
          enableHighAccuracy: true,
        }
      ),
    []
  )

  return location
}
